import React from 'react'
import classnames from 'classnames/bind'
import type { Listing } from '@adc/sdk/types'
import * as blueprint from '@adc/blueprint'
import ListingIndicator from '../listingIndicator'
import cls from './styles.scss'

const cx = classnames.bind(cls)

// Single source of truth lives in @adc/blueprint (shared with mobile).
export const buildSiblingListingPaths =
  blueprint.listing.utils.buildSiblingListingPaths

export interface DualTrackLobIndicatorsProps {
  listing: Listing
  /** `row` = inline with divider (cards); `column` = stacked (list rows). */
  direction?: 'row' | 'column'
  /** Apply bold 14px weight (SRP cards, popup). Leave false for lighter contexts (saved rows). */
  bold?: boolean
  elmId?: string
  className?: string
}

const DualTrackLobIndicators = ({
  listing,
  direction = 'row',
  bold = false,
  elmId,
  className,
}: DualTrackLobIndicatorsProps) => {
  const paths = buildSiblingListingPaths(listing)
  if (paths.length < 2) return null

  return (
    <div
      className={`${cx('lob-indicators', direction, { bold })}${
        className ? ` ${className}` : ''
      }`}
      data-elm-id={`${elmId}_lob_indicators`}
    >
      {paths.map((pathListing, i) => (
        <React.Fragment key={i}>
          {direction === 'row' && i > 0 && (
            <span className={cx('lob-divider')}>|</span>
          )}
          <ListingIndicator
            listing={pathListing}
            elmId={`${elmId}_lob_${i}`}
            className={cx('lob-indicator')}
            hideAuctionDate
            hideAuctionType
          />
        </React.Fragment>
      ))}
    </div>
  )
}

export default DualTrackLobIndicators
